/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_3moInputs */

const en_pricing_3mo = /** @type {(inputs: Pricing_3moInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 months`)
};

const id_pricing_3mo = /** @type {(inputs: Pricing_3moInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Bulan`)
};

/**
* | output |
* | --- |
* | "3 months" |
*
* @param {Pricing_3moInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_3mo = /** @type {((inputs?: Pricing_3moInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_3moInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_3mo(inputs)
	return en_pricing_3mo(inputs)
});